export default "__VITE_ASSET__a023d1a7__"